/* one% hero film: autoplay muted (skipped under reduced motion), Pause/Play toggle, pause off-screen. */
(function () {
  // Shared in-page anchor scroll (-56px, smooth). Also in op-announcement.js / op-header.js; runs once.
  if (!window.__opAnchorScroll) {
    window.__opAnchorScroll = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[data-op-scroll]') : null;
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
      if (!url.hash || url.pathname !== window.location.pathname) return;
      var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!el) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = el.getBoundingClientRect().top + window.scrollY - 56;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  if (customElements.get('op-hero')) return;

  class OpHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-op-hero-video]');
      this.toggle = this.querySelector('[data-op-hero-toggle]');
      if (!this.video) return;

      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.wanted = !reduce; // what the visitor wants: film running or not
      this.visible = true;
      this.video.muted = true;

      if (this.toggle) {
        this.toggle.hidden = false;
        this.onToggle = () => {
          this.wanted = !this.wanted;
          if (this.wanted) this.play(); else this.video.pause();
          this.sync();
        };
        this.toggle.addEventListener('click', this.onToggle);
      }

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (!this.visible) this.video.pause();
          else if (this.wanted) this.play();
        });
        this.io.observe(this);
      }

      if (this.wanted) this.play();
      this.sync();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.toggle && this.onToggle) this.toggle.removeEventListener('click', this.onToggle);
    }

    play() {
      if (!this.visible) return;
      this.video.preload = 'auto';
      const p = this.video.play();
      if (p && p.catch) {
        p.catch(() => {
          // Autoplay refused (e.g. low-power mode): show the poster and offer Play.
          this.wanted = false;
          this.sync();
        });
      }
    }

    sync() {
      if (!this.toggle) return;
      const label = this.wanted ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel;
      if (label) this.toggle.textContent = label;
      this.toggle.dataset.state = this.wanted ? 'playing' : 'paused'; // phones show only the matching icon
    }
  }

  customElements.define('op-hero', OpHero);
})();
